// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const cartData = createApi({
  reducerPath: "cartApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    getCart: builder.query({
      query: (student_id) => ({
        url: `cart_details`,
        params: {
          student_id,
        },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    addCart: builder.mutation({
      query: (body) => ({
        url: `add_cart`,
        method: "POST",
        body,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    deleteCart: builder.mutation({
      query: (body) => ({
        url: `delete_cart`,
        method: "POST",
        body,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getCities: builder.query({
      query: (state_id) => ({
        url: `get_city`,
        params: {
          state_id,
        },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getStates: builder.query({
      query: () => ({
        url: `get_states`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    addAddress: builder.mutation({
      query: (body) => ({
        url: `add_address`,
        method: "POST",
        body,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getOrderSummary: builder.query({
      query: ({ student_id, cart_ids, coupon_code }) => ({
        url: `order_summery`,
        params: {
          student_id,
          cart_ids,
          coupon_code,
        },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    applyCoupon: builder.mutation({
      query: (body) => ({
        url: `use_coupon`,
        method: "POST",
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCartQuery,
  useAddCartMutation,
  useDeleteCartMutation,
  useGetCitiesQuery,
  useGetStatesQuery,
  useAddAddressMutation,
  useGetOrderSummaryQuery,
  useApplyCouponMutation,
} = cartData;
